import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function register_svg_icons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer): () => Promise<any> {
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        iconRegistry.addSvgIcon(
          'dynamic_worksheet',
          sanitizer.bypassSecurityTrustResourceUrl('/assets/images/desking/dynamic-worksheet-ico.svg')
        );
        resolve();
      }, 0);
    });
  };
}

@NgModule({
  imports: [],
  providers: [{ provide: APP_INITIALIZER, useFactory: register_svg_icons, deps: [MatIconRegistry, DomSanitizer], multi: true }]
})
export class AppLoadModule {}
